// extracted by mini-css-extract-plugin
export var blogArticleHero = "blogArticleArchiveHero-module--blogArticleHero--dea36";
export var blogAuthorThumbnailContainer = "blogArticleArchiveHero-module--blogAuthorThumbnailContainer--6c815";
export var categoryArchive = "blogArticleArchiveHero-module--categoryArchive--121c0";
export var description = "blogArticleArchiveHero-module--description--3ce2e";
export var headline = "blogArticleArchiveHero-module--headline--ba83b";
export var heroImage = "blogArticleArchiveHero-module--heroImage--9d9b5";
export var layoutTwo = "blogArticleArchiveHero-module--layoutTwo--3c4e9";
export var textContainer = "blogArticleArchiveHero-module--textContainer--3bfa1";